import { render, staticRenderFns } from "./ExamVaultList.vue?vue&type=template&id=15a55edb&scoped=true"
import script from "./ExamVaultList.vue?vue&type=script&lang=js"
export * from "./ExamVaultList.vue?vue&type=script&lang=js"
import style0 from "./ExamVaultList.vue?vue&type=style&index=0&id=15a55edb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.31_css-loader@6.11.0_webpack@5.105.4__ejs@3.1._edcc41725b38a2c96ace736fbd249f4c/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a55edb",
  null
  
)

export default component.exports